function getFriendlyTime(time) {
  var hourShipTextSplit = time.split(":");
  var hourShipHour = parseInt(hourShipTextSplit[0]) || 16;
  var hourShipMinute = hourShipTextSplit[1] || "00";
  var suffix = hourShipHour <= 11 ? "AM" : "PM";
  x = ((hourShipHour + 11) % 12) + 1 + ":" + hourShipMinute + " " + suffix;
  return x;
}

function independentGetDate(daySelected) {
  var monthArray = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var localDate = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" }),
  );
  if (daySelected == "tomorrow") {
    var usersCurrentSetDate = localDate.setDate(localDate.getDate() + 1);
  } else {
    var usersCurrentSetDate = localDate.setDate(localDate.getDate());
  }
  var usersCurrentDate = new Date(usersCurrentSetDate);
  var usersCurrentDateMonth = monthArray[usersCurrentDate.getMonth()];
  var usersCurrentDateDay = usersCurrentDate.getDate();
  var usersCurrentDateYear = usersCurrentDate.getFullYear();
  var usersCurrentDate = `${usersCurrentDateMonth} ${usersCurrentDateDay}, ${usersCurrentDateYear}`;
  return usersCurrentDate;
}

const getTime = () => {
  // Get related date data from the #shipping-meesage HTML element
  const timeSpan = document.getElementById("shipping-meesage");
  const holidays =
    document.getElementById("shipping-meesage").dataset.holidays || "";
  const hourShip =
    document.getElementById("shipping-meesage").dataset.shippingHour || "16:30";
  const hourShipText = getFriendlyTime(hourShip);

  // Get current date in America/New_York timezone
  const localDate = new Date(
    new Date().toLocaleString("en-US", { timeZone: "America/New_York" }),
  );

  const monthArray = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Helper function to check if a date is a holiday
  const isHoliday = (date) => {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const holidayFormat = `//${month}, ${day}//`;
    return holidays.includes(holidayFormat);
  };

  // Helper function to get next business day (skips weekends and holidays)
  const getNextBusinessDay = (startDate, daysToAdd = 1) => {
    let checkDate = new Date(startDate);
    checkDate.setDate(checkDate.getDate() + daysToAdd);

    // Keep skipping until we find a non-weekend, non-holiday day
    let attempts = 0;
    while (attempts < 14) {
      // Prevent infinite loop (max 2 weeks)
      const dayName = checkDate.toLocaleString("en-US", {
        weekday: "long",
      });
      const month = checkDate.getMonth() + 1;
      const day = checkDate.getDate();
      const holidayFormat = `//${month}, ${day}//`;

      // If it's a weekend or holiday, skip to next day
      if (
        dayName === "Saturday" ||
        dayName === "Sunday" ||
        holidays.includes(holidayFormat)
      ) {
        checkDate.setDate(checkDate.getDate() + 1);
        attempts++;
      } else {
        break;
      }
    }
    return checkDate;
  };

  // Get current time components
  const weekDay = localDate.toLocaleString("en-US", { weekday: "long" });
  const currentHour = localDate.getHours();
  const currentMinute = localDate.getMinutes();
  const currentTimeInMinutes = currentHour * 60 + currentMinute;

  // Parse cutoff time
  const hourShipParts = hourShip.split(":");
  const hourShipHour = parseInt(hourShipParts[0]) || 16;
  const hourShipMinute = parseInt(hourShipParts[1]) || 30;
  const cutoffTimeInMinutes = hourShipHour * 60 + hourShipMinute;

  // Determine shipping date
  let shippingDate;
  let isToday = false;

  // Check if today is a weekend or holiday
  const todayIsWeekend = weekDay === "Saturday" || weekDay === "Sunday";
  const todayIsHoliday = isHoliday(localDate);

  if (todayIsWeekend || todayIsHoliday) {
    // Today is weekend or holiday, ship next business day
    shippingDate = getNextBusinessDay(localDate, 1);
  } else if (currentTimeInMinutes < cutoffTimeInMinutes) {
    // Before cutoff - can ship today
    shippingDate = new Date(localDate);
    isToday = true;
  } else {
    // After cutoff - ship next business day
    if (weekDay === "Friday") {
      // Friday after cutoff -> skip weekend -> Monday (but check if Monday is holiday)
      shippingDate = getNextBusinessDay(localDate, 3);
    } else {
      // Other weekdays after cutoff -> next business day
      shippingDate = getNextBusinessDay(localDate, 1);
    }
  }

  // Format shipping date
  const shipDateMonth = monthArray[shippingDate.getMonth()];
  const shipDateDay = shippingDate.getDate();
  const shipDateYear = shippingDate.getFullYear();
  const shipDateFormatted = `${shipDateMonth} ${shipDateDay}, ${shipDateYear}`;

  // Calculate remaining time until cutoff
  const now = localDate.getTime();
  const cutoffDate = new Date(`${shipDateFormatted} ${hourShip}`);
  const cutoffTime = cutoffDate.getTime();
  const distance = cutoffTime - now;

  const hoursRemaining = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
  );
  const minutesRemaining = Math.floor(
    (distance % (1000 * 60 * 60)) / (1000 * 60),
  );
  const secondsRemaining = Math.floor((distance % (1000 * 60)) / 1000);

  const remainingTime =
    `${hoursRemaining > 0 ? hoursRemaining + (hoursRemaining === 1 ? " hour" : " hours") : ""} ${minutesRemaining > 0 && hoursRemaining === 0 ? minutesRemaining + (minutesRemaining === 1 ? " minute" : " minutes") : "" + (hoursRemaining === 0 && minutesRemaining === 0 && secondsRemaining > 0 ? secondsRemaining + (secondsRemaining === 1 ? " second" : " seconds") : "")}`.trim();
  const orderWithinHtml = remainingTime
    ? ` <span class="wwis-ow-text">order within <span class="wwis-ow-time">${remainingTime}</span></span>`
    : "";

  // Format display message
  let displayHtml = "";
  const todayFormatted = independentGetDate("today");
  const tomorrowFormatted = independentGetDate("tomorrow");

  if (isToday) {
    // Shipping date is today's date. Display "Today".
    displayHtml = `<span class="wwis-day-text">today</span><span class="wwis-punctuation">:</span>${orderWithinHtml}`;
  } else if (shipDateFormatted === todayFormatted) {
    // Shipping date is today's date. Display "Today".
    displayHtml = `<span class="wwis-day-text">today</span><span class="wwis-punctuation">:</span>${orderWithinHtml}`;
  } else if (shipDateFormatted === tomorrowFormatted) {
    // Shipping date is tomorrow. Display "Tomorrow".
    displayHtml = `<span class="wwis-day-text">tomorrow</span><span class="wwis-punctuation">:</span>${orderWithinHtml}`;
  } else {
    // Shipping date is further than today or tomorrow - display actual date with order by message
    displayHtml = `<span class="wwis-day-text">${shipDateFormatted}</span> (Order by ${hourShipText || "4pm"} ET)`;
  }

  if (timeSpan) {
    timeSpan.innerHTML = displayHtml;
  }
};

// Run function once the HTML document has been completely parsed
window.addEventListener("DOMContentLoaded", () => {
  setInterval(getTime, 500);
});
